import script from "./InspectorTexture.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorTexture.vue?vue&type=script&setup=true&lang=js"

import "./InspectorTexture.vue?vue&type=style&index=0&id=9a76b384&scoped=true&lang=scss"
import "./InspectorTexture.vue?vue&type=style&index=1&id=9a76b384&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a76b384"]])

export default __exports__